import { AutoComplete, Button, Flex, Form, FormProps, message, Modal, Select, TimePicker, Image, Input } from "antd";
import { observer } from "mobx-react-lite";
import { useStore } from "../../stores/root-store-context";
import dayjs, { Dayjs } from 'dayjs';
import { PlusOutlined } from '@ant-design/icons';
import TextArea from "antd/es/input/TextArea";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { TimeReport } from "../../api/TimeReportsApiClient";
import { Roles } from "../../stores/EmployeesStore";

export const AddTimeReport = observer((props: { isModalOpen: boolean, hideModal: () => void, projectId?: string, userId?: string, isChangeUser: boolean }) => {
    const { isModalOpen, hideModal, projectId, userId, isChangeUser } = props;
    const { applicationStore, timeReportStore, employeesStore, projectsStore } = useStore();

    const [form] = Form.useForm();
    const { t } = useTranslation();

    const onFinish: FormProps<any>['onFinish'] = async (timeReport: any) => {
        const projectId = form.getFieldValue("projectId");
        const description = form.getFieldValue("description");
        const userId = form.getFieldValue("userId");
        const time = dayjs(form.getFieldValue("time")).format("HH:mm");
        timeReportStore.add(projectId, time, userId, description).then(() => {
            timeReportStore.getMyTime(applicationStore.user.id);
        }).finally(() => {
            if (applicationStore.user.roleId === Roles.Financier) {
                timeReportStore.getForFinancier();
            } else {
                timeReportStore.getAll();
            }
            form.resetFields();
            hideModal();
        });
    };

    useEffect(() => {
        if(isModalOpen){
            form.setFieldValue("user", `${employeesStore.users.find(el => el.id === userId)?.firstName} ${employeesStore.users.find(el => el.id === userId)?.lastName}`);
            form.setFieldValue("userId", userId);
            form.setFieldValue("project", projectsStore.projects.find(el => el.id === projectId)?.title);
            form.setFieldValue("projectId", projectId);
        }
    }, [userId, projectId, isModalOpen])

    return (
        <Modal title={t('LogTime')} open={isModalOpen} footer={null} onCancel={hideModal}>
            <Form form={form}
                onFinish={onFinish}
                labelCol={{ span: 4 }}
                labelAlign="left">
                <Form.Item<any> name="projectId" hidden>
                    <Input />
                </Form.Item>
                <Form.Item<any> name="userId" hidden>
                    <Input />
                </Form.Item>
                <Form.Item<any> label={t('Project')} name="project" style={{ width: "100%" }} rules={[{ required: true }]} >
                    <AutoComplete
                        style={{ height: 40 }}
                        placeholder="Project"
                        options={projectsStore.projects?.map((el, index) => ({
                            value: el.title, label: <Flex gap={5}>
                                <span>{`${el.title}`}</span>
                            </Flex>,
                            data: el
                        }))}
                        onChange={(value, option: any) => {
                            form.setFieldValue("projectId", option.data?.id)
                        }}
                    />
                </Form.Item>
                <Form.Item<any> label={t('User')} name="user" style={{ width: "100%" }} rules={[{ required: true }]} >
                    <AutoComplete
                        disabled={!isChangeUser}
                        style={{ height: 40 }}
                        placeholder="User name"
                        options={employeesStore.users?.map((el, index) => ({
                            key: index,
                            value: `${el.firstName} ${el.lastName}`,
                            data: el,
                            label: <Flex gap={5}>
                                <Image
                                    width={40}
                                    height={40}
                                    preview={false}
                                    style={{ borderRadius: "50%", objectFit: "cover" }}
                                    src={el.photoId ? `https://res.cloudinary.com/dnl3x07wo/image/upload/w_300/${el.photoId}` :
                                        `https://res.cloudinary.com/dnl3x07wo/image/upload/w_300/z03w7hlsy8hcoic9dlcn`
                                    }
                                />
                                <div>
                                    <div>{el.firstName}{el.lastName}</div>
                                    <div>{el.email}</div>
                                </div>
                            </Flex>
                        }))}
                        onChange={(value, option: any) => {
                            form.setFieldValue("userId", option.data?.id)
                        }}
                    />
                </Form.Item>
                <Form.Item<any> label={t('Time')} name="time" style={{ width: "100%" }} rules={[{ required: true }]} >
                    <TimePicker defaultValue={dayjs('00:00', 'HH:mm')} format={'HH:mm'} onCalendarChange={(date: any) => {
                        form.setFieldValue("time", date)
                    }} />
                </Form.Item>
                <Form.Item<any> label={t('Description')} name="description" style={{ width: "100%" }} rules={[{ required: true }]} >
                    <TextArea rows={4} />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" className="theme-btn" htmlType="submit" style={{ height: 65, float: "right" }}>
                        {t("Add")}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    )
})